import { useImmerAtom } from "jotai-immer";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Storage } from "@/store";

/**
 * Hook to sync the language between Jotai store and i18next
 * This should be used in your App component or a top-level provider
 */
export const useLanguageSync = () => {
  const [settings, setSettings] = useImmerAtom(Storage.settings);
  const { i18n } = useTranslation();

  // Sync i18next language with store on mount and when settings change
  useEffect(() => {
    if (settings.language && i18n.language !== settings.language) {
      i18n.changeLanguage(settings.language);
    }
  }, [settings.language, i18n]);

  // Listen to i18next language changes and update store
  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setSettings((draft) => {
        draft.language = lng;
      });
    };

    i18n.on("languageChanged", handleLanguageChange);
    return () => i18n.off("languageChanged", handleLanguageChange);
  }, [i18n, setSettings]);
};

export const SettingsUtils = {
  useLanguageSync,
};
